import ViewModel from '@/ViewModels/ViewModel';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import ButtonViewModel from '@/ViewModels/Controls/ButtonViewModel';
import LabelViewModelBuilder from '@/Builder/LabelViewModelBuilder';
import RADApplication from '@/Management/RADApplication';
import ButtonViewModelBuilder from '@/Builder/ButtonViewModelBuilder';
import {IOperationResultDTO} from "coreframetypings/dto";
import Utilities from '@/Utility/Utilities';
import ComponentManager from '@/Management/ComponentManager';
import {IViewModelConstructorParameter} from '#/CoreFrameInterfaces';

interface ITwoFactorAuthViewModelConstructorParameter extends IViewModelConstructorParameter {
    userName: string;
    surAndLastname: string;
}

export default class TwoFactorAuthViewModel extends ViewModel {
    public token: KnockoutObservable<string>;
    public titleInstr: LabelViewModel;
    public textInstr: LabelViewModel;
    public userLabel: LabelViewModel;
    public surAndLastname: LabelViewModel;
    public resetButton: ButtonViewModel;
    public userName: string;

    public constructor(protected params: ITwoFactorAuthViewModelConstructorParameter) {
        super(params);
        
        this.token = this.observableOrDefault(null);
        this.userLabel = this.createUserLabel();
        this.surAndLastname = this.createSurAndLastname();
        this.titleInstr = this.createLabelHeadingInstr();
        this.textInstr = this.createTextInstr();
        this.userName = this.paramOrDefault(params.userName, null);

        this.resetButton = this.createResetButton();
    }

    public updateUserLabel(ergNameString: string): void {
        this.userLabel.caption(ergNameString);
    }

    public updateSurAndLastname(name: string): void {
        this.surAndLastname.caption(name);
    }

    protected createUserLabel(): LabelViewModel {
        return new LabelViewModelBuilder()
            .withCaption(this.params.userName)
            .build();
    }

    private createSurAndLastname(): LabelViewModel {
        return new LabelViewModelBuilder()
            .withCaption(this.params.surAndLastname)
            .build();
    }

    private createLabelHeadingInstr(): LabelViewModel {
        return new LabelViewModelBuilder()
            .withErgName('RAD.RADFOUNDATION.PROBLEMDOMAIN.USER_QR_TITLE_INSTRUCTIONS_APP')
            .build();
    }

    private createTextInstr(): LabelViewModel {
        return new LabelViewModelBuilder()
            .withErgName('RAD.RADFOUNDATION.PROBLEMDOMAIN.USER_QR_INSTRUCTIONS_APP')
            .withSimpleReplacement('appname', RADApplication.getInstance().appName())
            .build();
    }

    public createResetButton(): ButtonViewModel {
        return new ButtonViewModelBuilder()
            .withOnClick(() => this.generateToken(true))
            .withLabel().withErgName('RAD.RADFOUNDATION.PROBLEMDOMAIN.USER_QR_GENERATE_NEW_TOKEN').done()
            .withLocator('generate-token')
            .withParentLocator(this.locator)
            .build()
    }
    
    public generateToken(update: boolean): void {
        this.callGenerateToken(update)
            .then((result) => {
                if (this.validateStatus(result)) {
                    const token = result.returnValue;
                    if (!Utilities.isNullOrUndefinedOrBlank(token)) {
                        this.token(token);
                        this.generateTokenCallback(update);
                    }
                }
            });
    }

    public callGenerateToken(update: boolean): JQueryPromise<IOperationResultDTO> {
        return RADApplication.getInstance().currentDetailViewContext()?.callOperationUnchecked('GenerateTwoFactorToken', [update], false, true).promise() ?? Utilities.resolveImmediately(null);
    }

    public generateTokenCallback(update: boolean): void {
        if (update)
            RADApplication.getInstance().currentDetailViewContext()?.genericObject.isModified(true);
    }
}

ComponentManager.setViewModel('TwoFactorAuthViewModel', TwoFactorAuthViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');